export default "__VITE_ASSET__DYGrkQnE__"